import { Currency } from "@daytrip/legacy-enums";
import { Expose, Transform } from "class-transformer";
import { IsUUID, IsNumber, IsString, IsDate, IsBoolean, ValidateIf } from "class-validator";
import { v4 as uuid } from "uuid";

import { InvoiceCurrencyRates } from "../interfaces/InvoiceCurrencyRates";
import { CDBaseEntity, CDEntity, CDObjectIdColumn, CDColumn } from "../orm";
import { TransformToDate } from "../transformers/transformToDate";

import type { BillingInformation } from "./BillingInformation";
import type { InvoiceItem } from "./InvoiceItem";

@CDEntity("invoices")
export class Invoice extends CDBaseEntity {
    @CDObjectIdColumn()
    @IsUUID("4")
    @Expose()
    public _id: string = uuid();

    @CDColumn()
    @IsString()
    @Expose()
    public prefix: string;

    @CDColumn()
    @IsNumber()
    @ValidateIf((invoice) => invoice.totalAmount > 0)
    @Expose()
    public invoiceNumber: number;

    @CDColumn()
    @IsString()
    @Expose()
    public invoiceEntity: string;

    @CDColumn()
    @IsString()
    @Expose()
    public userId: string;

    @CDColumn()
    @Expose()
    public userInvoiceInfo: BillingInformation & { isInvoiceInformation: true };

    @CDColumn()
    @IsDate()
    @TransformToDate
    @Expose()
    public issuedAt: Date;

    @CDColumn()
    @IsDate()
    @TransformToDate
    @Expose()
    public servicedAt?: Date; // not used

    @CDColumn()
    @Expose()
    public invoiceCurrency: Currency;

    @CDColumn()
    @Expose()
    public baseCurrency: Currency;

    @CDColumn()
    @Expose()
    public items: InvoiceItem[] = [];

    @CDColumn()
    @IsBoolean()
    @Expose()
    public isVat: boolean;

    @CDColumn()
    @IsBoolean()
    @Expose()
    public isReverseCharge: boolean;

    @CDColumn()
    @Expose()
    public invoiceTotalAmount: number;

    @CDColumn()
    @Expose()
    public totalAmount: number;

    @CDColumn()
    @Expose()
    public rates: InvoiceCurrencyRates;

    @CDColumn()
    @IsDate()
    @TransformToDate
    @Expose()
    public invoicingDateTo: Date;

    @CDColumn()
    @IsDate()
    @Transform((value) => (value === undefined ? undefined : new Date(value)))
    @Expose()
    public invoicingDateFrom: Date;

    public get dueDate(): Date {
        const dueDate = new Date(this.issuedAt);
        dueDate.setUTCDate(dueDate.getUTCDate() + 3);

        return dueDate;
    }

    public get invoiceTotalAmountDisplay(): string {
        return (this.invoiceTotalAmount / 100).toFixed(2);
    }

    public get totalAmountDisplay(): string {
        return (this.totalAmount / 100).toFixed(2);
    }
}
